export function isGroupAdmin(group, userId) {
  if (!group || !userId) return false;
  const uid = userId.toString();
  const creatorId = (group.creator?._id || group.creator)?.toString();
  if (creatorId && creatorId === uid) return true;
  const admins = Array.isArray(group.admins) ? group.admins : [];
  return admins.some((a) => (a._id || a).toString() === uid);
}

export function getEligibleNewAdmins(group, leavingUserId) {
  if (!group?.members) return [];
  const leavingId = leavingUserId.toString();
  return group.members.filter((m) => {
    const memberId = (m.user?._id || m.user).toString();
    return memberId !== leavingId;
  });
}
